// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconTaskClock = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 17.25a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0zM17.25 12a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5z"
      fill="currentColor"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.25 13.848a.75.75 0 01.75.75V16.5h1.902a.75.75 0 010 1.5H17.25a.75.75 0 01-.75-.75v-2.652a.75.75 0 01.75-.75zM9.75 1.5a3 3 0 00-3 3 .75.75 0 01-.75.75H2.25A.75.75 0 001.5 6v15.75c0 .414.336.75.75.75h7.5a.75.75 0 010 1.5h-7.5A2.25 2.25 0 010 21.75V6a2.25 2.25 0 012.25-2.25h3.062a4.501 4.501 0 018.876 0h3.062A2.25 2.25 0 0119.5 6v2.25a.75.75 0 01-1.5 0V6a.75.75 0 00-.75-.75H13.5a.75.75 0 01-.75-.75 3 3 0 00-3-3z"
      fill="currentColor"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75 3a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25z"
      fill="currentColor"
    />
  );
export default SvgIconTaskClock;
